import { MenuOutlined } from "@ant-design/icons";
import useMobileStore from "@bodhistreams/stores/src/mobileStore";
import { Button, Col, Drawer, Layout, Row, theme } from "antd";
import { useEffect, useState } from "react";
import Logo from "../Logo";
import Navigation from "../Navigation";
import UserMenu from "../UserMenu";

const { Header: AntHeader } = Layout;
const { useToken } = theme;

const Header = () => {
	const { token } = useToken();
	const { isMobile, windowWidth, initialize } = useMobileStore();
	const [drawerVisible, setDrawerVisible] = useState(false);

	useEffect(() => {
		const cleanup = initialize();
		return cleanup;
	}, [initialize]);

	// Adjusted breakpoint for mobile nav menu
	const isNavMenu = windowWidth < 880;

	return (
		<AntHeader
			style={{
				background: "transparent",
				padding: `0 ${token.paddingLG}px`,
				top: 0,
				zIndex: 1000,
				width: "100%",
				display: "flex",
				alignItems: "center",
				textShadow: "0 1px 3px rgba(0, 0, 0, 0.15)",
			}}
		>
			<Row justify="space-between" align="middle" style={{ width: "100%" }}>
				{/* Logo on the left */}
				<Col>
					<Logo.Favicon hyperlink={true} size={34} />
				</Col>

				{/* Navigation and user menu on the right */}
				<Col
					style={{ display: "flex", alignItems: "center", gap: token.marginMD }}
				>
					{/* Custom navigation menu */}
					{!isNavMenu && <Navigation mode="horizontal" />}

					{/* User menu (now includes the Studio button) */}
					<UserMenu showStudio={true} />

					{/* Mobile menu button */}
					{(isNavMenu || isMobile) && (
						<Button
							type="text"
							icon={<MenuOutlined style={{ color: token.colorText }} />}
							onClick={() => setDrawerVisible(true)}
						/>
					)}
				</Col>
			</Row>

			{/* Mobile drawer */}
			{(isNavMenu || isMobile) && (
				<Drawer
					title={<Logo.Favicon hyperlink={true} size={24} />}
					placement="right"
					onClose={() => setDrawerVisible(false)}
					open={drawerVisible}
					width={480}
				>
					<Navigation mode="vertical" />
					{/* No need for Studio button here anymore, it's part of UserMenu now */}
				</Drawer>
			)}
		</AntHeader>
	);
};

export default Header;
